import React from 'react';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';
import {Button, Icon, Typography} from '@bonprix/design-system';
import UserFlyoutTextItem from '@header/scripts/components/user/UserFlyoutTextItem.jsx';
import UserFlyoutLinkItem from '@header/scripts/components/user/UserFlyoutLinkItem.jsx';

export default function UserFlyoutContent({userStatus, texts, links, closeFlyout}) {
    const sendLandmark = (landmark) => {
        LandmarkAdapter.sendClickLandmark(landmark);
    };

    return (
        <>
            <div className="header__my-account-flyout-content -top">
                {userStatus.guest ? (
                    <>
                        <UserFlyoutTextItem text={texts.myaccount_popup_account} />
                        <UserFlyoutTextItem text={texts.myaccount_my_orders} />
                        <UserFlyoutTextItem text={texts.myaccount_my_bills} />
                    </>
                ) : (
                    <>
                        <UserFlyoutLinkItem
                            url={links.MY_ACCOUNT}
                            landmark="topleiste_layer_myaccount"
                            text={texts.myaccount_popup_account}
                        />
                        <UserFlyoutLinkItem
                            url={links.MY_ACCOUNT_ORDER}
                            landmark="topleiste_layer_order"
                            text={texts.myaccount_my_orders}
                        />
                        <UserFlyoutLinkItem
                            url={links.MY_ACCOUNT_INVOICE}
                            landmark="topleiste_layer_billing"
                            text={texts.myaccount_my_bills}
                        />
                    </>
                )}
            </div>

            <div className={`header__my-account-flyout-separator${userStatus.loggedIn ? ' -visible' : ''}`}></div>

            {userStatus.loggedIn ? (
                <>
                    <div className="header__my-account-flyout-content -bottom">
                        <Typography component="div" variant={'body1'} color="primary" align="center">
                            {texts.myaccount_logged_in_as}
                            <Typography component="div" variant={'body1'} color="on-bg-mid" align="center">
                                {userStatus.guest ? <>{texts.cus_userFlyout_guestName}</> : userStatus.username}
                            </Typography>
                        </Typography>

                        <UserFlyoutLinkItem
                            url={links.MY_ACCOUNT_LOGOUT}
                            landmark="topleiste_layer_logout"
                            text={texts.myaccount_logout_popup}
                            hideUnderline={false}
                        />
                    </div>
                </>
            ) : (
                <div className="header__my-account-flyout-content -bottom">
                    <Button
                        link={true}
                        href={links.MY_ACCOUNT_LOGIN}
                        className="my-account__log-in-button"
                        onClick={() => sendLandmark('topleiste_anmelden')}
                    >
                        {texts.header_myaccount_login}
                    </Button>

                    <UserFlyoutLinkItem
                        url={links.MY_ACCOUNT_REGISTRATION}
                        landmark="topleiste_layer_reg"
                        text={texts.myaccount_register_popup}
                        hideUnderline={false}
                    />
                </div>
            )}

            <button className="header__my-account-flyout-closer" onClick={closeFlyout}>
                <Icon variant="closer" />
            </button>
        </>
    );
}
